interface PaginationLink {
  url: string;
  page: string;
}

enum SortOption {
  asc = "",
  desc = "-",
}

enum PageDirection {
  first = "first",
  next = "next",
  previous = "prev",
}

export { PaginationLink, SortOption, PageDirection };
